import { useBranding } from "@/hooks/useBranding";

const Footer = () => {
  const { branding } = useBranding();
  const name = branding?.appName || branding?.displayName || "IMS People Possible AI";

  return (
    <footer className={"border-t border-gray-700 text-center text-gray-500 text-sm px-6 py-3"}>
      <p className={`text-sm text-gray-500`}>{name} Recruitment System © {new Date().getFullYear()}</p>
    </footer>
  );
};

export default Footer;
